import React, {Component} from 'react';
import './App.scss';
import {Header} from "./components/structure";
import {reduxWrapper} from "./globalState";
import {AdminViewWrapper} from "./admin/adminViewWrapper";
import PopupManager from "./components/popups";
import {Button, RelativeRoute, RelativeSwitch} from "./components/common/common";
import {Route} from "react-router-dom";
import {FormInput, ValidateForm} from "./components/common/formValidation";
import {AppearTransition} from "./components/animations";

import LockIcon from "./resources/icons/lockOpen.svg";
import FacebookIcon from "./resources/icons/facebook-white.svg";
import Bg5 from "./resources/images/cocktailFive.png";
import {Modal} from "./components/common/modal";

class AppRender extends Component {
	render() {
		return (
			<PopupManager>
				<Header key="header"/>
				<section className="mainContent greenScrollbar" id="content">
					<RelativeSwitch>
						<Route path="/login" component={LoginView}/>
						<Route component={AdminViewWrapper}/>
					</RelativeSwitch>
				</section>
			</PopupManager>
		);
	}
}

const App = reduxWrapper("getUserId", "getPartyExists", "getCreateParty")(AppRender);

class LoginViewRender extends React.Component {
	
	state = {
		error: null
	};
	
	render() {
		const {login, facebookLogin, history} = this.props;
		return (
			<Modal onHide={() => null} icon={LockIcon} title="LOG IND" background={Bg5}>
				<Button className="facebookLogin"
				        onClick={() => facebookLogin({success: () => history.replace("/")})}
				        icon={FacebookIcon}>
					Log ind med Facebook
				</Button>
				<span>eller</span>
				<ValidateForm onSubmit={val => login({data: val, success: () => history.replace("/")})} className="login">
					<AppearTransition animation="growCenter" show={this.state.error != null}>
						<p className="error">{this.state.error}</p>
					</AppearTransition>
					<FormInput name="email" rules="email" type="email" req/>
					<FormInput name="password" title="Kodeord" type="password" placeholder="password" req/>
					<Button className="btnWhite" submit>LOGIN</Button>
				</ValidateForm>
			</Modal>
		)
	}
}

const LoginView = reduxWrapper("getLogin", "getFacebookLogin")(LoginViewRender);

//</editor-fold>

export default App;



// WEBPACK FOOTER //
// ./src/App.js